import { useTranslation } from 'react-i18next';
import { FC } from 'react';
import * as S from './Banned.styles';
import { IconBox } from '@/components/UI/IconBox/IconBox.styles';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { PageTopControls } from '@/components/PageTopControls';
import { Header } from '@/components/Header';

interface BannedViewProps {
  title?: string;
  description: string;
}

export const BannedView: FC<BannedViewProps> = ({ title, description }) => {
  const { t } = useTranslation();

  return (
    <S.Wrapper>
      <PageTopControls>
        <Header hasAddNew />
      </PageTopControls>
      <S.Container>
        <S.MessageBox>
          <IconBox
            $filename="banned.png"
            $width={114}
            $height={82}
            $iconWidth={114}
            $iconHeight={82}
          />
          <Typography.Title $variant="5">
            {title || t('common.attention')}
          </Typography.Title>
          <S.Description>{description}</S.Description>
        </S.MessageBox>
      </S.Container>
    </S.Wrapper>
  );
};

BannedView.displayName = 'BannedView';
